import type { ScheduledPayload } from "../../../../TransferSchedule";
import type {
  InternalLoanPaymentPayload,
  LoanPaymentPayloadV2,
  LoanPaymentByCardPayload,
} from "../../../../types/models/v1";
import type { NetworkPayload } from "../../../composites/request/request.types";

const internalLoanPaymentsUrl = "internal_loan_payments/";

export const API = {
  /**
   * @deprecated Use `makeInternalLoanPayment()`
   */
  makeInternalPrincipalPayment: (
    payload: InternalLoanPaymentPayload<"principal">,
  ): NetworkPayload => {
    return {
      url: internalLoanPaymentsUrl,
      options: {
        method: "POST",
        payload,
      },
    };
  },
  /**
   * @deprecated Use `makeInternalLoanPayment()`
   */
  makeInternalDefaultPayment: (
    payload: InternalLoanPaymentPayload<"default">,
  ): NetworkPayload => {
    return {
      url: internalLoanPaymentsUrl,
      options: {
        method: "POST",
        payload,
      },
    };
  },
  /**
   * @deprecated Use `makeInternalLoanPayment()` or `makeExternalLoanPayment()`
   */
  makeInternalPayment: (
    payload: InternalLoanPaymentPayload<"default" | "principal">,
    fromAccountSource: string = "institution",
  ): NetworkPayload => {
    return {
      url:
        fromAccountSource === "external"
          ? "loan_payments/ach"
          : internalLoanPaymentsUrl,
      options: {
        method: "POST",
        payload,
      },
    };
  },

  makeInternalLoanPayment: (payload: LoanPaymentPayloadV2): NetworkPayload => {
    return {
      url: "internal_loan_payments/",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  makeExternalLoanPayment: (payload: LoanPaymentPayloadV2): NetworkPayload => {
    return {
      url: "loan_payments/ach",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  makeScheduledTransfer: (payload: ScheduledPayload): NetworkPayload => {
    return {
      url: "transfers/scheduled",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  makeCardLoanPayment: (
    payload: LoanPaymentByCardPayload,
    userId: API.UserId,
  ): NetworkPayload => {
    return {
      url: `users/${userId}/payment`,
      options: {
        method: "POST",
        payload,
      },
    };
  },
};
